export enum Direction {
  Step1 = 1,
  Step2 = 2,
  // Step3 = 3,
}
